module.exports = __webpack_public_path__ + "img/coloured-logo-dark-text.26be168e.png";